export const DigitalSignalsEndpoint = {
  GET_DATA: '/default/digital-signals/get-data',
  GET_DIGITAL_SIGNALS_FOR_DATALOGGER: '/default/digital-signals/get-digital-signals-for-datalogger',
  SET_DIGITAL_SIGNALS_ERROR_STATE: '/default/digital-signals/set-error-state',
  GET_USER_PRIVILEGES: '/default/digital-signals/get-privileges',
};
